class BeforeYouLeave extends HTMLElement {
  constructor() {
    super();
    this.popup = this.querySelector('.modal--popup');
    this.overlay = this.querySelector('[id^="Modal-Overlay-"]');
    this.panel = this.querySelector('.popup__inner');
    this.delay = (Number(this.dataset.expireMinutes) || 1) * 60000;
    this.timer = null;
    this.onActivity = this.resetTimer.bind(this);
    this.querySelector('.popup__close')?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());
    this.onEscape = event => { if (event.key === 'Escape' && this.popup?.hasAttribute('open')) this.close(); };
  }
  connectedCallback() {
    if (!this.popup) return;
    if (this.querySelector('.aoraki-newsletter-popup__success')) { this.open(); return; }
    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:select', event => { if (event.target === this.closest('.shopify-section')) this.open(); });
      document.addEventListener('shopify:section:deselect', event => { if (event.target === this.closest('.shopify-section')) this.close(false); });
      return;
    }
    try { if (Number(localStorage.getItem('aoraki_newsletter_popup_dismissed')) > Date.now()) return; } catch (_) {}
    ['mousemove','keydown','scroll'].forEach(name => document.addEventListener(name,this.onActivity,{passive:true}));
    document.addEventListener('keydown',this.onEscape);
    this.resetTimer();
  }
  disconnectedCallback() {
    clearTimeout(this.timer);
    ['mousemove','keydown','scroll'].forEach(name => document.removeEventListener(name,this.onActivity));
    document.removeEventListener('keydown',this.onEscape);
  }
  resetTimer() {
    if (this.popup?.hasAttribute('open')) return;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => { if (!document.body.classList.contains('overflow-hidden')) this.open(); },this.delay);
  }
  open() {
    clearTimeout(this.timer);
    this.popup?.setAttribute('open','true');
    this.popup?.setAttribute('aria-hidden','false');
    document.body.classList.add('overflow-hidden');
    document.documentElement.setAttribute('scroll-lock','');
    this.querySelector('input[name="contact[first_name]"]')?.focus();
  }
  close(remember = true) {
    this.popup?.removeAttribute('open');
    this.popup?.setAttribute('aria-hidden','true');
    document.body.classList.remove('overflow-hidden');
    document.documentElement.removeAttribute('scroll-lock');
    if (remember && !window.Shopify?.designMode) {
      try { localStorage.setItem('aoraki_newsletter_popup_dismissed',String(Date.now()+86400000)); } catch (_) {}
    }
  }
}
if (!customElements.get('before-you-leave')) customElements.define('before-you-leave',BeforeYouLeave);

